// Variables globales
let lenis;
let customCursor;

// Mantener control manual del scroll
if ('scrollRestoration' in history) {
	history.scrollRestoration = 'manual';
}

document.addEventListener('DOMContentLoaded', function () {
	// Verificar si ya se vio la intro para ocultarla inmediatamente si es necesario
	const hasSeenIntro = sessionStorage.getItem('hasSeenIntro') === 'true';
	const introHome = document.querySelector('.intro-home');
	
	if (hasSeenIntro && introHome) {
		// Si ya se vio la intro, ocultarla inmediatamente sin transición
		introHome.style.display = 'none';
	}
	
	// Inicializar cursor una sola vez - FUERA de Barba
	customCursor = new CustomCursor();
	
	// Solo inicializar Barba.js si el usuario NO está logueado
	if (typeof ajax_forms !== 'undefined' && ajax_forms.isUserLoggedIn === 'false') {
		barbaJsInit();
	} else {
		// Usuario logueado: inicializar todo directamente sin Barba
		initSmoothScroll();
		marquee();
		contentAnimation();
		
		// Asegurar que la intro esté oculta para usuarios logueados
		if (introHome) {
			introHome.style.display = 'none';
		}
		
		// Inicializar videos con hover para proyectos y reproducir otros videos
		initProjectVideoHover();
		initDesktopProjectCardsOpacity();

		// Inicializar videos
		initHeroVideo();
		initPlyrVideos();

		// Inicializar animaciones mobile para project cards
		initMobileProjectCardsHover();

		// Reproducir solo videos que NO están en tarjetas de proyecto ni en hero
		if (document.querySelectorAll('video').length) {
			document.querySelectorAll('video').forEach((video) => {
				if (!video.closest('.project-card') && !video.classList.contains('hero-local-video')) {
					video.play();
				}
			});
		}
	}
});

function delay(n) {
	n = n || 2000;
	return new Promise((done) => {
		setTimeout(() => {
			done();
		}, n);
	});
}

function contentAnimation() {
	scrollElementos();
	menu();
	formulariosAjax();
	inputFilledStates();
	initCustomValidation();
	initHeroVideoEffect();
	initGlobalLinkHover();

	// Actualizar referencias del cursor para nuevos elementos
	if (customCursor) {
		customCursor.refreshHoverElements();
	}

	// Inicializar funcionalidad de hover para videos en proyectos
	initProjectVideoHover();

	// Inicializar videos
	initHeroVideo();
	initPlyrVideos();

	// Inicializar animaciones mobile para project cards
	initMobileProjectCardsHover();

	// Inicializar accordion de equipo (página about)
	initAboutTeamAccordion();

	// Inicializar efecto hover en archive de proyectos
	initProjectsArchiveEffect();

	// Slider de imágenes/videos en mobile para proyectos
	initMobileProjectSlider();

	// Solo reproducir videos que NO están en tarjetas de proyecto, hero ni archive
	if (document.querySelectorAll('video').length) {
		document.querySelectorAll('video').forEach((video) => {
			if (!video.closest('.project-card') && !video.classList.contains('hero-local-video') && !video.closest('.projects-archive__background')) {
				video.play();
			}
		});
	}
}

/* ------------------ GSAP ------------------ */

// Sistema de cursor personalizado - Implementación moderna con quickTo
class CustomCursor {
	constructor() {
		this.element = null;
		this.trails = [];
		this.xTo = null;
		this.yTo = null;
		this.trailXTo = [];
		this.trailYTo = [];
		this.isInitialized = false;
		this.mouseX = 0;
		this.mouseY = 0;

		this.init();
	}
	
	init() {
		if (this.isInitialized) return;

		this.element = document.querySelector('.puntero');
		if (!this.element) {
			console.warn('Cursor element .puntero not found');
			return;
		}

		// Crear elementos trail
		this.createTrails();

		// Configuración inicial del cursor principal
		gsap.set(this.element, {
			xPercent: -50,
			yPercent: -50,
			scale: 1,
			visibility: 'visible',
			force3D: true
		});

		// Configurar quickTo para cursor principal
		this.xTo = gsap.quickTo(this.element, "x", {
			duration: 0.15,
			ease: "power3",
			overwrite: true
		});

		this.yTo = gsap.quickTo(this.element, "y", {
			duration: 0.15,
			ease: "power3",
			overwrite: true
		});

		// Configurar quickTo para cada trail
		this.trails.forEach((trail, index) => {
			gsap.set(trail, {
				xPercent: -50,
				yPercent: -50,
				scale: 1 - (index * 0.1), // Escala más gradual para 6 elementos
				visibility: 'visible',
				force3D: true
			});

			this.trailXTo[index] = gsap.quickTo(trail, "x", {
				duration: 0.2 + (index * 0.05), // Duración más gradual
				ease: "power3",
				overwrite: true
			});

			this.trailYTo[index] = gsap.quickTo(trail, "y", {
				duration: 0.2 + (index * 0.05),
				ease: "power3",
				overwrite: true
			});
		});

		// Timer para ocultar trails cuando el mouse se detiene
		this.moveTimer = null;

		// Event listener para movimiento del mouse
		window.addEventListener('mousemove', (e) => {
			this.mouseX = e.clientX;
			this.mouseY = e.clientY;

			// Mover cursor principal
			this.xTo(this.mouseX);
			this.yTo(this.mouseY);

			// Mostrar trails durante el movimiento
			this.showTrails();

			// Mover trails con delay
			this.trails.forEach((trail, index) => {
				setTimeout(() => {
					this.trailXTo[index](this.mouseX);
					this.trailYTo[index](this.mouseY);
				}, index * 20); // Delay más corto para 6 elementos (20ms entre cada uno)
			});

			// Resetear timer para ocultar trails
			clearTimeout(this.moveTimer);
			this.moveTimer = setTimeout(() => {
				this.hideTrails();
			}, 100); // Ocultar trails después de 100ms sin movimiento
		});

		// Ocultar cursor al salir de la ventana del navegador
		document.addEventListener('mouseleave', () => {
			if (this.element) {
				gsap.to(this.element, { opacity: 0, duration: 0.2 });
				this.hideTrails();
			}
		});
		document.addEventListener('mouseenter', () => {
			if (this.element) {
				gsap.to(this.element, { opacity: 1, duration: 0.2 });
			}
		});

		// Configurar efectos hover
		this.setupHoverEffects();

		this.isInitialized = true;
		console.log('✅ Custom cursor with white trails initialized');
	}

	createTrails() {
		// Crear 6 elementos trail con efecto anaglifo
		for (let i = 0; i < 6; i++) {
			const trail = document.createElement('div');
			trail.className = `puntero-trail puntero-trail-${i + 1}`;
			document.body.appendChild(trail);
			this.trails.push(trail);
		}
	}

	showTrails() {
		// Mostrar trails con opacidades progresivas para 6 elementos
		this.trails.forEach((trail, index) => {
			const opacity = Math.max(0.8 - (index * 0.13), 0.1); // 0.8, 0.67, 0.54, 0.41, 0.28, 0.15
			gsap.to(trail, {
				opacity: opacity,
				duration: 0.2,
				ease: "power2.out"
			});
		});
	}

	hideTrails() {
		// Ocultar todos los trails
		this.trails.forEach(trail => {
			gsap.to(trail, {
				opacity: 0,
				duration: 0.3,
				ease: "power2.out"
			});
		});
	}
	
	setupHoverEffects() {
		// Inputs, checkboxes, radios y labels - cursor pequeño
		const inputElements = document.querySelectorAll('input[type="checkbox"], input[type="radio"], input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="password"], textarea, select, label');
		
		inputElements.forEach(element => {
			element.addEventListener('mouseenter', () => this.addInputHoverEffect());
			element.addEventListener('mouseleave', () => this.removeInputHoverEffect());
		});
		
		// Enlaces y botones - cursor grande (después para tener prioridad)
		const interactiveElements = document.querySelectorAll('a, .link, button');
		
		interactiveElements.forEach(element => {
			element.addEventListener('mouseenter', (e) => {
				// Remover clase input-hover si estaba activa
				this.removeInputHoverEffect();
				this.addHoverEffect();
				e.stopPropagation(); // Evitar que se propague al label padre
			});
			element.addEventListener('mouseleave', (e) => {
				this.removeHoverEffect();
				// Si el elemento padre es un label, restaurar el cursor pequeño
				if (element.closest('label')) {
					this.addInputHoverEffect();
				}
				e.stopPropagation();
			});
		});
	}
	
	addHoverEffect() {
		if (this.element) {
			this.element.classList.add('enlace');
			document.body.classList.add('cursor-enlace-hover');
		}
	}

	removeHoverEffect() {
		if (this.element) {
			this.element.classList.remove('enlace');
			document.body.classList.remove('cursor-enlace-hover');
		}
	}

	addInputHoverEffect() {
		if (this.element) {
			this.element.classList.add('input-hover');
			document.body.classList.add('cursor-input-hover');
		}
	}

	removeInputHoverEffect() {
		if (this.element) {
			this.element.classList.remove('input-hover');
			document.body.classList.remove('cursor-input-hover');
		}
	}
	
	refreshHoverElements() {
		// Actualizar referencia del elemento después de transiciones
		const newElement = document.querySelector('.puntero');
		if (newElement && newElement !== this.element) {
			this.element = newElement;
			
			// Reconfigurar quickTo con el nuevo elemento
			this.xTo = gsap.quickTo(this.element, "x", {
				duration: 0.2,
				ease: "power3",
				overwrite: true
			});
			
			this.yTo = gsap.quickTo(this.element, "y", {
				duration: 0.2,
				ease: "power3",
				overwrite: true
			});
			
			// Configuración inicial del nuevo elemento
			gsap.set(this.element, {
				xPercent: -50,
				yPercent: -50,
				scale: 1,
				visibility: 'visible',
				force3D: true
			});
		}
		
		// IMPORTANTE: Limpiar estado hover al actualizar elementos
		this.resetCursor();
		
		// Reconfigurar efectos hover para nuevos elementos
		this.setupHoverEffects();
	}
	
	resetCursor() {
		// Método para limpiar completamente el estado del cursor
		if (this.element) {
			this.element.classList.remove('enlace', 'input-hover');
		}
		// Limpiar clases del body para los trails
		document.body.classList.remove('cursor-enlace-hover', 'cursor-input-hover');
	}
	
	
	destroy() {
		if (this.element) {
			window.removeEventListener('mousemove', this.handleMouseMove);
			this.xTo = null;
			this.yTo = null;
			this.element = null;
			this.isInitialized = false;
		}
	}
}

function sectionProyecto() {
	if (document.querySelectorAll('.prod-imgs__img.effect').length) {
		var lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));

		if ('IntersectionObserver' in window) {
			var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
				entries.forEach(function (video) {
					if (video.isIntersecting) {
						for (var source in video.target.children) {
							var videoSource = video.target.children[source];
							if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
								videoSource.src = videoSource.dataset.src;
							}
						}

						video.target.load();
						video.target.classList.remove('lazy');
						lazyVideoObserver.unobserve(video.target);
					}
				});
			});

			lazyVideos.forEach(function (lazyVideo) {
				lazyVideoObserver.observe(lazyVideo);
			});
		}

		gsap.utils.toArray('.prod-imgs__img.effect').forEach((section) => {
			ScrollTrigger.create({
				trigger: section,
				start: 'top top',
				pin: true,
				pinSpacing: false,
				markers: false,
				onEnter: () => {
					// if (section.querySelectorAll('video').length) {
					// 	section.querySelectorAll('video').forEach((video) => {
					// 		video.play();
					// 	});
					// }
				},
				onEnterBack: () => {
					// if (section.querySelectorAll('video').length) {
					// 	section.querySelectorAll('video').forEach((video) => {
					// 		video.play();
					// 	});
					// }
				},
				onLeave: () => {
					// if (section.querySelectorAll('video').length) {
					// 	section.querySelectorAll('video').forEach((video) => {
					// 		video.play();
					// 	});
					// }
				},
				onLeaveBack: () => {
					// if (section.querySelectorAll('video').length) {
					// 	section
					// 		.querySelectorAll('video')
					// 		.forEach((video) => {
					// 			video.pause();
					// 		});
					// }
				},
			});
		});
	}
}

function pageTransition() {
	return new Promise((resolve) => {
		const transition = document.querySelector('.page-transition');
		
		if (transition) {
			// Mostrar el fundido blanco
			transition.classList.add('active');
			
			// Esperar a que la transición termine y resolver la promesa
			setTimeout(() => {
				resolve();
			}, 700); // Esperar un poco más que la duración de la transición CSS (0.6s)
		} else {
			resolve();
		}
	});
}

function efectoLetrasHome() {
	if (document.querySelectorAll('.animation-intro-2').length || document.querySelectorAll('.animation-intro-3').length) {
		// Procesar texto con SplitType incluyendo words y chars
		const textos2 = new SplitType('.animation-intro-2', { types: 'words, chars' });
		const textos3 = new SplitType('.animation-intro-3', { types: 'words, chars' });

		// Verificar si estamos en la intro o en transición
		const introHome = document.querySelector('.intro-home');
		const isIntro = introHome && introHome.style.display !== 'none' && window.getComputedStyle(introHome).display !== 'none';
		
		// Delay diferente según contexto
		const delay = isIntro ? 2.5 : 0.1; // 2.5s en intro, 0.1s en transiciones
		
		// Crear timeline para animación secuencial
		const tl = gsap.timeline({ delay: delay });

		// Hacer visibles las palabras primero, luego animar las letras
		tl.set(['.animation-intro-2 .word', '.animation-intro-3 .word'], { opacity: 1 })
		  .to('.animation-intro-2 .char', {
			y: 0,
			stagger: 0.05,
			duration: 0.1,
			ease: 'power2.out'
		  })
		  .to('.animation-intro-3 .char', {
			y: 0,
			stagger: 0.05,
			duration: 0.1,
			ease: 'power2.out'
		  }, "-=0.1"); // Empezar ligeramente antes de que termine la primera línea
	}
}

function scrollElementos() {
	if (document.querySelectorAll('.animation-scroll').length) {
		gsap.registerPlugin(ScrollTrigger);

		// Usar la misma técnica: SplitType con words y chars, pero excluir contenedores con enlaces
		const animationElements = document.querySelectorAll('.animation-scroll');
		const textElements = Array.from(animationElements).filter(el => !el.querySelector('.link'));
		
		let textos3 = new SplitType(textElements, { 
			types: 'words, chars',
			// Configuración para prevenir saltos
			lineClass: 'line',
			wordClass: 'word', 
			charClass: 'char',
			preserveWhitespace: true
		});

		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.section',
				start: 'top center',
				toggleClass: 'animado',
				toggleActions: 'play none none none',
			},
		});

		// Hacer visibles tanto las palabras como los elementos directos
		tl.set('.animation-scroll', { opacity: 1 }) // Para elementos sin words
		  .set('.animation-scroll .word', { opacity: 1 }) // Para palabras
		  .to('.animation-scroll .char', {
			y: 0,
			stagger: 0.05,
			delay: 0,
			duration: 0.1,
		})
		  // Animar enlaces por separado con el mismo timing que las letras
		  .to('.animation-scroll .link.char', {
			y: 0,
			delay: 0.1, // Pequeño delay adicional para que aparezca después del texto
			duration: 0.1, // Misma duración que las letras
			// Sin ease definido - usar el por defecto como las letras
		}, "-=0.05"); // Ajustado para sincronizar mejor
	}
}

function menu() {
	const burger = document.querySelector('.burger');
	const header = document.querySelector('header');
	const headerBar = document.querySelector('.header');

	// Verificar que los elementos existen
	if (!burger || !header) {
		console.warn('Menu elements not found:', { burger: !!burger, header: !!header });
		return;
	}

	burger.addEventListener('click', () => {
		header.classList.toggle('active-menu');
	});

	// Cerrar menú al hacer clic en un enlace del menú (útil en desktop)
	const menuLinks = document.querySelectorAll('.menu-mobile a');
	menuLinks.forEach(link => {
		link.addEventListener('click', () => {
			// Pequeño delay para permitir la navegación
			setTimeout(() => {
				header.classList.remove('active-menu');
			}, 100);
		});
	});

	// Cerrar menú con ESC (mejora la UX en desktop)
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && header.classList.contains('active-menu')) {
			header.classList.remove('active-menu');
		}
	});

	// Ocultar header al hacer scroll hacia abajo, mostrar al subir
	if (headerBar) {
		let lastScrollY = window.scrollY;
		let ticking = false;

		window.addEventListener('scroll', () => {
			if (!ticking) {
				requestAnimationFrame(() => {
					const currentScrollY = window.scrollY;

					// No ocultar si el menú móvil está abierto
					if (!header.classList.contains('active-menu')) {
						if (currentScrollY > lastScrollY && currentScrollY > 80) {
							// Scroll hacia abajo - ocultar
							headerBar.classList.add('header--hidden');
						} else {
							// Scroll hacia arriba - mostrar
							headerBar.classList.remove('header--hidden');
						}
					}

					lastScrollY = currentScrollY;
					ticking = false;
				});
				ticking = true;
			}
		});
	}
}

/* ------------------ VANILLA ANIMACIONES ------------------ */
function marquee() {
	const marquees = document.querySelectorAll('div.marquee');
	let currentScrollSpeedMultiplier = 1; // Velocidad actual (interpolada)
	let scrollDirection = 1; // 1 = hacia abajo, -1 = hacia arriba
	let lastScrollY = window.scrollY;
	let lastScrollTime = performance.now();
	let scrollVelocity = 0;
	
	// Sistema de ease-out progresivo como Lenis (más suave)
	const lenisEasing = 0.05; // Interpolación más lenta para suavidad
	const maxMultiplier = 15; // Multiplicador reducido para menos brusquedad
	const velocityThreshold = 0.3; // Menos sensible para evitar cambios bruscos

	// Detectar scroll y calcular velocidad y dirección
	window.addEventListener('scroll', () => {
		const currentScrollY = window.scrollY;
		const currentTime = performance.now();
		const timeDelta = currentTime - lastScrollTime;
		const scrollDelta = Math.abs(currentScrollY - lastScrollY);
		
		// Detectar dirección del scroll
		if (currentScrollY > lastScrollY) {
			scrollDirection = 1; // Scroll hacia abajo
		} else if (currentScrollY < lastScrollY) {
			scrollDirection = -1; // Scroll hacia arriba
		}
		
		// Calcular velocidad de scroll (píxeles por ms)
		if (timeDelta > 0) {
			scrollVelocity = scrollDelta / timeDelta;
		}
		
		lastScrollY = currentScrollY;
		lastScrollTime = currentTime;
	});

	marquees.forEach(function (element) {
		let tick = 1;
		let value = element.dataset.speed;
		element.innerHTML += element.innerHTML;
		element.innerHTML += element.innerHTML;

		const innerTags = element.querySelectorAll('div.inner');
		innerTags.forEach((inner, index) => {
			inner.style.left = inner.offsetWidth * index + 'px';
		});

		const ticker = function () {
			// Calcular objetivo basado en velocidad actual de scroll (más suave)
			const targetMultiplier = scrollVelocity > velocityThreshold ? 
				1 + (scrollVelocity * 1.5) : 1; // Reducido a 1.5 para transiciones más suaves
			
			// Limitar el máximo
			const clampedTarget = Math.min(targetMultiplier, maxMultiplier);
			
			// Interpolación continua hacia el objetivo calculado
			currentScrollSpeedMultiplier += (clampedTarget - currentScrollSpeedMultiplier) * lenisEasing;
			
			// Decay natural más progresivo (como Lenis)
			scrollVelocity *= 0.92;
			
			tick += parseInt(value) * 0.2 * currentScrollSpeedMultiplier * scrollDirection; // Aplicar dirección y velocidad
			//element.innerHTML = tick;
			//element.style.left = tick + "px";
			innerTags.forEach((inner, index) => {
				let width = inner.offsetWidth;
				let normalizedMarqueeX = ((tick % width) + width) % width;
				let pos = width * (index - 1) + normalizedMarqueeX;

				inner.style.left = pos + 'px';
			});
			requestAnimationFrame(ticker);
		};
		ticker();
	});
}

/*-------------- Validaciones Personalizadas ------------------- */

function initCustomValidation() {
	console.log('🔧 Inicializando sistema de validación personalizado');
	
	// Agregar patrón estricto a todos los campos de email
	const emailInputs = document.querySelectorAll('input[type="email"]');
	emailInputs.forEach(input => {
		if (!input.hasAttribute('pattern')) {
			input.setAttribute('pattern', '[a-zA-Z0-9._%\\+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}');
		}
	});
	
	// Crear sistema de notificaciones globales
	initGlobalNotifications();
	
	// Función para obtener mensaje de error específico
	function getErrorMessage(field) {
		// Para checkboxes de grupo (tags), siempre devolver mensaje específico
		if (field.type === 'checkbox' && field.hasAttribute('data-option') && field.getAttribute('data-option') === 'tags') {
			return 'Selecciona al menos una opción';
		}
		
		if (field.validity.valueMissing) {
			if (field.type === 'email') {
				return 'Por favor, introduce tu email';
			} else if (field.type === 'checkbox') {
				return 'Debes aceptar los términos para continuar';
			} else {
				return `Por favor, completa el campo "${field.placeholder || field.name || 'requerido'}"`;
			}
		} else if (field.validity.typeMismatch || field.validity.patternMismatch) {
			if (field.type === 'email') {
				return 'Introduce un email válido';
			} else {
				return 'El formato no es válido';
			}
		} else if (field.validity.tooShort) {
			return `El texto es demasiado corto (mínimo ${field.minLength} caracteres)`;
		}
		return 'Este campo no es válido';
	}
	
	// Función para validar grupo de checkboxes (tags)
	function validateCheckboxGroup(container) {
		const checkboxes = container.querySelectorAll('input[type="checkbox"][data-option="tags"]');
		
		// Verificar si algún checkbox del grupo es requerido
		const hasRequiredCheckbox = Array.from(checkboxes).some(cb => cb.hasAttribute('data-required') && cb.getAttribute('data-required') === 'required');
		
		// Solo validar si hay al menos un checkbox requerido en el grupo
		if (!hasRequiredCheckbox) {
			// Limpiar validación si no es requerido
			checkboxes.forEach(cb => cb.setCustomValidity(''));
			return null;
		}
		
		const isAnyChecked = Array.from(checkboxes).some(cb => cb.checked);
		
		if (!isAnyChecked) {
			// Marcar como inválido el primer checkbox del grupo para mostrar el error
			const firstCheckbox = checkboxes[0];
			if (firstCheckbox) {
				firstCheckbox.setCustomValidity('Selecciona al menos una opción');
				return firstCheckbox;
			}
		} else {
			// Limpiar validación personalizada de todos los checkboxes del grupo
			checkboxes.forEach(cb => cb.setCustomValidity(''));
		}
		return null;
	}
	
	// Función para mostrar mensaje de error en un campo específico
	function showFieldError(field, message) {
		// Buscar wrapper (input-wrapper, check o checkboxs para grupos)
		let wrapper = field.closest('.input-wrapper') || field.closest('.check');
		
		// Para checkboxes de grupo (tags), usar el .field-wrapper.checkboxs
		if (!wrapper && field.hasAttribute('data-option') && field.getAttribute('data-option') === 'tags') {
			wrapper = field.closest('.field-wrapper.checkboxs');
		}
		
		if (!wrapper) return;
		
		// Buscar mensaje existente o crear uno nuevo
		let errorElement = wrapper.querySelector('.field-error-message');
		if (!errorElement) {
			errorElement = document.createElement('div');
			errorElement.className = 'field-error-message';
			// Insertar el mensaje al final del wrapper para que aparezca debajo de todo
			wrapper.appendChild(errorElement);
		}
		
		errorElement.textContent = message;
		wrapper.classList.add('input-error');
	}
	
	// Función para limpiar error de un campo específico
	function clearFieldError(field) {
		// Buscar wrapper (input-wrapper, check o checkboxs para grupos)
		let wrapper = field.closest('.input-wrapper') || field.closest('.check');
		
		// Para checkboxes de grupo (tags), usar el .field-wrapper.checkboxs
		if (!wrapper && field.hasAttribute('data-option') && field.getAttribute('data-option') === 'tags') {
			wrapper = field.closest('.field-wrapper.checkboxs');
		}
		
		if (!wrapper) return;
		
		wrapper.classList.remove('input-error');
		const errorElement = wrapper.querySelector('.field-error-message');
		if (errorElement) {
			errorElement.textContent = '';
		}
	}
	
	// Interceptar envíos de formularios para validación personalizada
	// EXCLUIR formularios que tienen lógica AJAX específica (newsletter y contact)
	const forms = document.querySelectorAll('form:not([data-form="newsletter"])');
	console.log(`📝 Encontrados ${forms.length} formularios para validación estándar`);
	
	forms.forEach(form => {
		form.addEventListener('submit', function(e) {
			// Limpiar errores previos
			clearAllFieldErrors(form);
			
			// Validar grupos de checkboxes antes de la validación HTML5
			const checkboxContainers = form.querySelectorAll('.field-wrapper.checkboxs');
			let hasCheckboxErrors = false;
			
			checkboxContainers.forEach(container => {
				const invalidCheckbox = validateCheckboxGroup(container);
				if (invalidCheckbox) {
					hasCheckboxErrors = true;
					const message = getErrorMessage(invalidCheckbox);
					showFieldError(invalidCheckbox, message);
				}
			});
			
			// Verificar validez del formulario HTML5
			const isFormValid = form.checkValidity();
			
			if (!isFormValid || hasCheckboxErrors) {
				e.preventDefault();
				
				// Mostrar mensajes de error individuales para cada campo inválido
				const invalidFields = form.querySelectorAll(':invalid');
				invalidFields.forEach(field => {
					// Solo mostrar error si no es un checkbox de grupo (ya procesado arriba)
					if (!(field.hasAttribute('data-option') && field.getAttribute('data-option') === 'tags')) {
						const message = getErrorMessage(field);
						showFieldError(field, message);
					}
				});
				
				// Hacer focus en el primer campo inválido
				const firstInvalidField = form.querySelector(':invalid') || form.querySelector('.field-wrapper.checkboxs.input-error input[type="checkbox"]');
				if (firstInvalidField) {
					firstInvalidField.focus();
				}
			} else {
				// Si el formulario es válido, limpiar cualquier error previo
				clearAllFieldErrors(form);
			}
		});
		
		// Validación en tiempo real cuando el usuario escribe
		const inputs = form.querySelectorAll('input, textarea');
		inputs.forEach(input => {
			// Limpiar errores cuando el usuario empiece a escribir
			input.addEventListener('input', function() {
				if (input.checkValidity()) {
					clearFieldError(input);
				} else {
					// Mostrar error en tiempo real solo si ya había un error previo
					const wrapper = input.closest('.input-wrapper');
					if (wrapper && wrapper.classList.contains('input-error')) {
						const message = getErrorMessage(input);
						showFieldError(input, message);
					}
				}
			});
			
			// Validar al salir del campo (blur)
			input.addEventListener('blur', function() {
				if (input.value.trim() !== '' && !input.checkValidity()) {
					const message = getErrorMessage(input);
					showFieldError(input, message);
				}
			});
		});
		
		// Validación en tiempo real para grupos de checkboxes
		const checkboxGroups = form.querySelectorAll('input[type="checkbox"][data-option="tags"]');
		checkboxGroups.forEach(checkbox => {
			checkbox.addEventListener('change', function() {
				const container = checkbox.closest('.field-wrapper.checkboxs');
				if (container) {
					// Validar el grupo completo cuando cambie cualquier checkbox
					const invalidCheckbox = validateCheckboxGroup(container);
					if (invalidCheckbox) {
						// Mantener el error si todavía no hay ninguno seleccionado
						const message = getErrorMessage(invalidCheckbox);
						showFieldError(invalidCheckbox, message);
					} else {
						// Limpiar el error cuando se seleccione al menos uno
						const firstCheckbox = container.querySelector('input[type="checkbox"][data-option="tags"]');
						if (firstCheckbox) {
							clearFieldError(firstCheckbox);
						}
					}
				}
			});
		});
		
		// Deshabilitar validación HTML nativa
		form.setAttribute('novalidate', 'novalidate');
	});
	
	// Agregar validación personalizada COMPLETA a formularios AJAX 
	const ajaxForms = document.querySelectorAll('form[data-form="newsletter"]');
	console.log(`📧 Encontrados ${ajaxForms.length} formularios AJAX para validación personalizada`);
	
	ajaxForms.forEach(form => {
		// INTERCEPTAR ENVÍO para validación personalizada
		form.addEventListener('submit', function(e) {
			// Limpiar errores previos
			clearAllFieldErrors(form);
			
			// Validar grupos de checkboxes antes de la validación HTML5
			const checkboxContainers = form.querySelectorAll('.field-wrapper.checkboxs');
			let hasCheckboxErrors = false;
			
			checkboxContainers.forEach(container => {
				const invalidCheckbox = validateCheckboxGroup(container);
				if (invalidCheckbox) {
					hasCheckboxErrors = true;
					const message = getErrorMessage(invalidCheckbox);
					showFieldError(invalidCheckbox, message);
				}
			});
			
			// Verificar validez del formulario HTML5
			const isFormValid = form.checkValidity();
			
			if (!isFormValid || hasCheckboxErrors) {
				e.preventDefault();
				e.stopPropagation();
				
				// Mostrar mensajes de error individuales para cada campo inválido
				const invalidFields = form.querySelectorAll(':invalid');
				invalidFields.forEach(field => {
					// Solo mostrar error si no es un checkbox de grupo (ya procesado arriba)
					if (!(field.hasAttribute('data-option') && field.getAttribute('data-option') === 'tags')) {
						const message = getErrorMessage(field);
						showFieldError(field, message);
					}
				});
				
				// Hacer focus en el primer campo inválido
				const firstInvalidField = form.querySelector(':invalid') || form.querySelector('.field-wrapper.checkboxs.input-error input[type="checkbox"]');
				if (firstInvalidField) {
					firstInvalidField.focus();
				}
				
				return false; // Evitar que se envíe
			}
			// Si el formulario es válido, permitir que el AJAX lo maneje
		});
		
		// Validación en tiempo real
		const inputs = form.querySelectorAll('input, textarea');
		inputs.forEach(input => {
			// Validación en tiempo real cuando el usuario escribe
			input.addEventListener('input', function() {
				if (input.checkValidity()) {
					clearFieldError(input);
				} else {
					// Mostrar error en tiempo real solo si ya había un error previo
					const wrapper = input.closest('.input-wrapper');
					if (wrapper && wrapper.classList.contains('input-error')) {
						const message = getErrorMessage(input);
						showFieldError(input, message);
					}
				}
			});
			
			// Validar al salir del campo (blur)
			input.addEventListener('blur', function() {
				if (input.value.trim() !== '' && !input.checkValidity()) {
					const message = getErrorMessage(input);
					showFieldError(input, message);
				}
			});
		});
		
		// Validación en tiempo real para grupos de checkboxes
		const checkboxGroups = form.querySelectorAll('input[type="checkbox"][data-option="tags"]');
		checkboxGroups.forEach(checkbox => {
			checkbox.addEventListener('change', function() {
				const container = checkbox.closest('.field-wrapper.checkboxs');
				if (container) {
					// Validar el grupo completo cuando cambie cualquier checkbox
					const invalidCheckbox = validateCheckboxGroup(container);
					if (invalidCheckbox) {
						// Mantener el error si todavía no hay ninguno seleccionado
						const message = getErrorMessage(invalidCheckbox);
						showFieldError(invalidCheckbox, message);
					} else {
						// Limpiar el error cuando se seleccione al menos uno
						const firstCheckbox = container.querySelector('input[type="checkbox"][data-option="tags"]');
						if (firstCheckbox) {
							clearFieldError(firstCheckbox);
						}
					}
				}
			});
		});
		
		// Deshabilitar validación HTML nativa
		form.setAttribute('novalidate', 'novalidate');
	});
	
	// Función para limpiar todos los errores de un formulario
	function clearAllFieldErrors(form) {
		const inputs = form.querySelectorAll('input, textarea');
		inputs.forEach(input => {
			clearFieldError(input);
		});
	}
}

/*-------------- Estados de Inputs ------------------- */

function inputFilledStates() {
	const inputWrappers = document.querySelectorAll('.input-wrapper');
	
	inputWrappers.forEach(wrapper => {
		const input = wrapper.querySelector('input, textarea');
		if (!input) return;
		
		// Función para verificar si el input está lleno
		const checkFilled = () => {
			if (input.value.trim() !== '') {
				wrapper.classList.add('input-filled');
			} else {
				wrapper.classList.remove('input-filled');
			}
		};
		
		// Verificar estado inicial
		checkFilled();
		
		// Event listeners para cambios
		input.addEventListener('input', checkFilled);
		input.addEventListener('change', checkFilled);
		input.addEventListener('blur', checkFilled);
	});
}

/*-------------- Formularios ------------------- */

function formulariosAjax() {
	const btnNews = document.querySelector('.newsletter-link'),
		formsContainer = document.querySelector('.newsletter'),
		formsExit = document.querySelector('.newsletter__exit'),
		formNews = document.querySelector('.newsletter #frm-contact');

	// Verificar que los elementos existen antes de agregar event listeners
	if (!btnNews || !formsContainer || !formsExit || !formNews) {
		console.warn('Newsletter elements not found:', {
			btnNews: !!btnNews,
			formsContainer: !!formsContainer,
			formsExit: !!formsExit,
			formNews: !!formNews
		});
		return;
	}

	// Cuando hago click en la x de la newsletter
	formsExit.addEventListener('click', () => {
		formsContainer.classList.remove('ver');
	});
	// Cuando hago click en el enlace del footer
	btnNews.addEventListener('click', () => {
		formsContainer.classList.toggle('ver');
	});
	// REMOVIDO: El newsletter ya no se cierra automáticamente con scroll
	// para mejorar la UX del usuario
	// Cuando hago click fuera del elemento elimino la clase ver
	formsContainer.addEventListener('click', function (event) {
		if (!formNews.contains(event.target)) {
			formsContainer.classList.remove('ver');
		}
	});

	$('#frm-contact').on('submit', function (e) {
		e.preventDefault();

		// VALIDAR FORMULARIO ANTES DE ENVIAR AJAX
		const form = this;
		const isFormValid = form.checkValidity();
		
		if (!isFormValid) {
			console.log('❌ Newsletter form validation failed');
			// Mostrar errores de validación - SIMPLIFICADO
			const invalidFields = form.querySelectorAll(':invalid');
			invalidFields.forEach(field => {
				let message = 'Este campo es requerido';
				if (field.type === 'email') {
					message = field.validity.valueMissing ? 'Por favor, introduce tu email' : 'Introduce un email válido';
				} else if (field.type === 'checkbox') {
					message = 'Debes aceptar los términos para continuar';
				}
				
				// Mostrar error simplificado
				let wrapper = field.closest('.input-wrapper') || field.closest('.check');
				if (wrapper) {
					wrapper.classList.add('input-error');
					let errorElement = wrapper.querySelector('.field-error-message');
					if (!errorElement) {
						errorElement = document.createElement('div');
						errorElement.className = 'field-error-message';
						wrapper.appendChild(errorElement);
					}
					errorElement.textContent = message;
				}
			});
			// Hacer focus en el primer campo inválido
			const firstInvalidField = form.querySelector(':invalid');
			if (firstInvalidField) {
				firstInvalidField.focus();
			}
			return false; // NO enviar AJAX si hay errores
		}
		
		console.log('✅ Newsletter form validation passed');
		var formData = $(this).serializeArray();
		console.log('📧 Newsletter form data:', formData);
		formData.push({name: 'action', value: 'libertacreative_ajax_frm_contact'});
		formData.push({name: 'nonce', value: ajax_forms.frmNonce});
		$.ajax({
			url: ajax_forms.ajaxUrl,
			type: 'post',
			dataType: 'json',
			data: formData,
			beforeSend: function () {
				$('#frm-contact .newsletter__svgs ').removeClass(['init', 'success']).addClass(['load']);
				$('#frm-contact .frm-message').removeClass('error').text(''); // Limpiar mensaje previo
				$('#frm-contact #submit').prop('disabled', true);
			},
		})
			.done(function (res) {
				console.log('📧 Newsletter response:', res);
				if (res.status === 1) {
					$('#frm-contact .newsletter__svgs ').removeClass(['init', 'load']).addClass(['success']);
					$('#frm-contact .frm-message').removeClass('error').text(''); // No mostrar mensaje en newsletter success
					$('#frm-contact')[0].reset();
				} else {
					$('#frm-contact .newsletter__svgs ').removeClass(['init', 'load']).addClass(['error']);
					// NO mostrar NINGÚN error en .frm-message del newsletter
					// Todos los errores del newsletter (validación y wp_mail) se manejan externamente
					$('#frm-contact .frm-message').removeClass('error').text('');
					console.log('📧 Newsletter error, but NOT showing in .frm-message:', res.message);
				}
			})
			.always(function () {
				$('#frm-contact #submit').prop('disabled', false);
			});
	});

}

/* ------------------ BARBAJS ------------------ */
function barbaJsInit() {
	barba.init({
		sync: true,
		debug: false,
		transitions: [
			{
				// Primera carga de la página
				once(data) {
					// Verificar si es primera visita
					const hasSeenIntro = sessionStorage.getItem('hasSeenIntro') === 'true';
					
					if (!hasSeenIntro) {
						// Primera visita: mostrar intro
						sessionStorage.setItem('hasSeenIntro', 'true');
						initWebAnimation();
						initSmoothScroll();
						marquee();
					} else {
						// Ya visitó: iniciar todo normal
						initSmoothScroll();
						marquee();
						contentAnimation();
					}
					
					// Reproducir videos (excluir hero con controles propios)
					if (document.querySelectorAll('video').length) {
						document.querySelectorAll('video').forEach((video) => {
							if (!video.classList.contains('hero-local-video')) {
								video.play();
							}
						});
					}
				},

				// Antes de salir de la página - animar cierre visual del menú
				beforeLeave(data) {
					const header = document.querySelector('header');
					const menuOverlay = document.querySelector('.menu-mobile');
					const menuUl = document.querySelector('.menu-mobile ul');
					
					if (header && header.classList.contains('active-menu')) {
						// X → hamburguesa (quitar active-menu del header)
						header.classList.remove('active-menu');
						
						// Mantener overlay visible durante transición
						if (menuOverlay) {
							menuOverlay.classList.add('transitioning');
						}
						
						// Letras → opacity 0 (transición suave)
						if (menuUl) {
							menuUl.style.opacity = '0';
						}
						
						// NO esperar - las transiciones de menú y página ocurren en paralelo
					}
				},
				
				// Salir de la página
				async leave(data) {
					const done = this.async();
					
					// Resetear cursor antes de la transición
					if (customCursor) {
						customCursor.resetCursor();
					}
					
					// Mostrar transición
					await pageTransition();
					await delay(200);
					done();
				},
				
				// Antes de entrar a la nueva página
				beforeEnter(data) {
					// Resetear cursor al cambiar de página
					if (customCursor) {
						customCursor.resetCursor();
					}
					
					// Scroll to top usando Lenis si está disponible
					if (window.lenis) {
						window.lenis.scrollTo(0, { immediate: true });
					} else {
						window.scrollTo(0, 0);
					}
				},
				
				// Entrar a la nueva página
				enter(data) {
					// Limpiar estado de transición del menú
					const menuOverlay = document.querySelector('.menu-mobile');
					const menuUl = document.querySelector('.menu-mobile ul');
					
					if (menuOverlay) {
						menuOverlay.classList.remove('transitioning');
					}
					if (menuUl) {
						menuUl.style.opacity = ''; // Resetear opacity inline
					}
					
					// Ocultar transición
					const transition = document.querySelector('.page-transition');
					if (transition) {
						transition.classList.remove('active');
					}
					
					// Pequeño delay para asegurar que el DOM esté listo
					setTimeout(() => {
						// Inicializar scripts
						marquee();
						efectoLetrasHome(); // Solo para transiciones entre páginas
						contentAnimation();
						
						// Reproducir videos (excluir hero con controles propios)
						if (document.querySelectorAll('video').length) {
							document.querySelectorAll('video').forEach((video) => {
								if (!video.classList.contains('hero-local-video')) {
									video.play();
								}
							});
						}
					}, 50); // Delay mínimo de 50ms
				}
			}
		]
	});
	
	// Hooks globales para manejo del scroll
	barba.hooks.enter(() => {
		// Scroll al top en cada navegación
		if (window.lenis) {
			window.lenis.scrollTo(0, { immediate: true });
		}
		
		// El cursor ya no necesita reinicialización porque está fuera del contenedor de Barba.js
	});
}

function initWebAnimation() {
	const introHome = document.querySelector('.intro-home');
	if (introHome) {
		// La intro ya está visible por defecto en CSS, solo agregar animación
		
		// Después de un momento, agregar la clase load para la animación
		setTimeout(() => {
			introHome.classList.add('load');
			efectoLetrasHome();
			
			// Esperar a que termine la transición CSS (opacity 1s + delay 2s = 3s)
			setTimeout(() => {
				introHome.style.display = 'none';
				contentAnimation();
			}, 3500); // 3.5 segundos para que termine toda la transición
		}, 100);
	}

	// Limpiar sessionStorage solo en recarga de página
	window.addEventListener('beforeunload', function () {
		sessionStorage.removeItem('hasSeenIntro');
	});
}

/**
 * Sistema de scroll suave con Lenis - Implementación optimizada
 */
function initSmoothScroll() {
	if (typeof Lenis !== 'undefined') {
		// Solo inicializar si no existe ya
		if (window.lenis) {
			window.lenis.destroy();
		}
		
		// Inicializar Lenis con configuración optimizada
		lenis = new Lenis({
			duration: 1.2,
			easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
			orientation: 'vertical',
			gestureOrientation: 'vertical',
			smoothWheel: true,
			wheelMultiplier: 1,
			touchMultiplier: 2,
			infinite: false,
			autoResize: true
		});

		// RAF loop optimizado
		function raf(time) {
			if (lenis) {
				lenis.raf(time);
				requestAnimationFrame(raf);
			}
		}
		requestAnimationFrame(raf);

		// Hacer Lenis disponible globalmente
		window.lenis = lenis;

		console.log('✅ Lenis smooth scroll initialized');
	} else {
		console.warn('⚠️ Lenis library not found');
	}
}

/*-------------- Sistema de Notificaciones Globales ------------------- */

function initGlobalNotifications() {
	// Crear el elemento de notificación global si no existe
	let globalNotification = document.querySelector('.global-notification');
	if (!globalNotification) {
		globalNotification = document.createElement('div');
		globalNotification.className = 'global-notification';
		document.body.appendChild(globalNotification);
	}
	
	// Función global para mostrar notificaciones
	window.showGlobalNotification = function(message, type = 'error', duration = 6000) {
		console.log(`🔔 showGlobalNotification called: "${message}", type: ${type}`);
		globalNotification.textContent = message;
		globalNotification.className = `global-notification ${type}`;
		
		// DEBUG: Verificar posición en pantalla
		console.log('📍 Element position before show:', globalNotification.getBoundingClientRect());
		console.log('📍 Element computed styles before show:', {
			position: window.getComputedStyle(globalNotification).position,
			top: window.getComputedStyle(globalNotification).top,
			right: window.getComputedStyle(globalNotification).right,
			zIndex: window.getComputedStyle(globalNotification).zIndex,
			opacity: window.getComputedStyle(globalNotification).opacity,
			visibility: window.getComputedStyle(globalNotification).visibility,
			display: window.getComputedStyle(globalNotification).display
		});
		
		// FORZAR la clase show con setTimeout para evitar problemas de timing
		setTimeout(() => {
			globalNotification.classList.add('show');
			console.log('📍 Classes after forced show:', globalNotification.className);
			console.log('📍 Element position after show:', globalNotification.getBoundingClientRect());
			console.log('📍 Element computed styles after show:', {
				opacity: window.getComputedStyle(globalNotification).opacity,
				visibility: window.getComputedStyle(globalNotification).visibility,
				transform: window.getComputedStyle(globalNotification).transform
			});
		}, 10);
		
		// Auto-ocultar después del tiempo especificado
		setTimeout(() => {
			globalNotification.classList.remove('show');
			console.log('⏰ Auto-hiding notification after', duration, 'ms');
		}, duration);
	};
	
	// TEST MANUAL: Agregar función de test global
	window.testNotification = function() {
		console.log('🧪 Testing notification manually...');
		showGlobalNotification('Test notification - should be visible!', 'error', 10000);
	};
	
	// Función global para ocultar notificaciones
	window.hideGlobalNotification = function() {
		globalNotification.classList.remove('show');
	};
	
	// Interceptar errores AJAX de WordPress (wp_mail, etc.)
	$(document).ajaxComplete(function(event, xhr, settings) {
		// Solo procesar respuestas JSON de nuestros formularios
		if (settings.data && settings.data.indexOf('libertacreative_ajax_frm_contact') !== -1) {
			try {
				const response = JSON.parse(xhr.responseText);

				console.log('📧 AJAX respuesta de formulario:', response);

				if (response.status === 0 && response.message) {
					showGlobalNotification(response.message, 'error');
				} else if (response.status === 1 && response.message) {
					showGlobalNotification(response.message, 'success', 4000);
				}
			} catch (e) {
				// Si no es JSON válido, ignorar
				console.warn('Error parsing AJAX response:', e);
			}
		}
	});

	// Inicializar Swiper para Magazine
	const magazineSwiper = document.querySelector('.magazine-swiper .swiper-wrapper');

	if (magazineSwiper) {
		const swiper = new Swiper('.magazine-swiper', {
			slidesPerView: 1,
			spaceBetween: 20,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 1.2,
					spaceBetween: 30,
				}
			}
		});
	}

	// Inicializar funcionalidad de hover para videos en proyectos
	initProjectVideoHover();

	// Inicializar videos
	initHeroVideo();
	initPlyrVideos();

	// Inicializar animaciones mobile para project cards
	initMobileProjectCardsHover();
}

// Función para manejar hover en videos de proyectos
function initProjectVideoHover() {
	const projectCards = document.querySelectorAll('.project-card');

	projectCards.forEach(card => {
		const defaultVideo = card.querySelector('.project-card__media--default video');
		const hoverVideo = card.querySelector('.project-card__media--hover video');

		if (defaultVideo) {
			// IMPORTANTE: Videos por defecto SIEMPRE reproduciendo
			forceVideoPlayback(defaultVideo);

			// Prevenir que se pause bajo cualquier circunstancia
			defaultVideo.addEventListener('pause', () => {
				setTimeout(() => defaultVideo.play().catch(() => {}), 10);
			});

			// Deshabilitar controles y interacciones que puedan pausar
			defaultVideo.addEventListener('click', (e) => {
				e.preventDefault();
				return false;
			});

			// Si hay video hover, configurar transición visual sin pausar el default
			if (hoverVideo) {
				// El video hover también debe estar listo para reproducir
				hoverVideo.addEventListener('loadeddata', () => {
					hoverVideo.currentTime = 0;
				});

				// IMPORTANTE: Video hover también debe reproducirse siempre
				forceVideoPlayback(hoverVideo);

				// Prevenir que el video hover se pause
				hoverVideo.addEventListener('pause', () => {
					setTimeout(() => hoverVideo.play().catch(() => {}), 10);
				});

				// El hover solo maneja la visibilidad CSS, no la reproducción
				card.addEventListener('mouseenter', () => {
					// Asegurar que el video por defecto sigue reproduciéndose
					if (defaultVideo.paused) {
						defaultVideo.play().catch(() => {});
					}

					// Preparar video hover si existe
					if (hoverVideo) {
						hoverVideo.play().catch(() => {});
					}
				});

				card.addEventListener('mouseleave', () => {
					// Asegurar que el video por defecto NUNCA se pause
					if (defaultVideo.paused) {
						defaultVideo.play().catch(() => {});
					}

					// Asegurar que el video hover también siga reproduciéndose
					if (hoverVideo && hoverVideo.paused) {
						hoverVideo.play().catch(() => {});
					}
				});
			}
		}
	});
}

// Función auxiliar para forzar reproducción continua
function forceVideoPlayback(video) {
	// Intentar reproducir inmediatamente
	video.play().catch(() => {
		// Si falla, intentar de nuevo en el próximo frame
		setTimeout(() => video.play().catch(() => {}), 16);
	});

	// Vigilancia cada 2 segundos para asegurar que sigue reproduciéndose
	const playbackWatcher = setInterval(() => {
		if (video.paused) {
			video.play().catch(() => {});
		}
	}, 2000);

	// Limpiar el watcher si el video se elimina del DOM
	const observer = new MutationObserver(() => {
		if (!document.contains(video)) {
			clearInterval(playbackWatcher);
			observer.disconnect();
		}
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
}

/* ------------------ EFECTO HERO VIDEO (CHARLIE) ------------------ */
function initHeroVideoEffect() {
	console.log('🎬 Iniciando initHeroVideoEffect');

	// Debug: Ver todas las clases que contienen "hero" o "video"
	const allHeroElements = document.querySelectorAll('[class*="hero"]');
	const allVideoElements = document.querySelectorAll('[class*="video"]');
	console.log('🔍 Elementos con "hero":', allHeroElements.length, allHeroElements);
	console.log('🔍 Elementos con "video":', allVideoElements.length, allVideoElements);

	// Intentar diferentes selectores
	const selectors = [
		'[class*="wp-block-acf-hero-video"]',
		'[class*="hero-video"]',
		'.hero-video',
		'[id*="hero-video"]',
		'section[class*="hero"]'
	];

	selectors.forEach(selector => {
		const elements = document.querySelectorAll(selector);
		console.log(`🎯 Selector "${selector}":`, elements.length, elements);
	});

	// Buscar el contenedor principal del hero-video (debe haber solo 1 por página)
	const heroVideoBlocks = document.querySelectorAll('.hero-video-background');
	console.log('📹 Hero video blocks encontrados:', heroVideoBlocks.length);

	// Si no encuentra con la clase específica, buscar con el selector más general
	if (heroVideoBlocks.length === 0) {
		const fallbackBlocks = document.querySelectorAll('[id*="hero-video"]');
		console.log('🔄 Fallback: buscando por ID, encontrados:', fallbackBlocks.length);
		if (fallbackBlocks.length > 0) {
			fallbackBlocks.forEach(block => heroVideoBlocks.push ? heroVideoBlocks.push(block) : '');
		}
	}

	heroVideoBlocks.forEach(function(heroVideoBlock, blockIndex) {
		console.log(`🎯 Procesando bloque ${blockIndex}:`, heroVideoBlock);

		// El contenedor parent que contiene tanto el background como la lista de proyectos
		const heroVideoSection = heroVideoBlock.closest('section') || heroVideoBlock.parentElement;

		const originalVideo = heroVideoBlock.querySelector('.hero-video--original');
		const projectVideos = heroVideoBlock.querySelectorAll('.hero-video--project');
		// Buscar items de proyecto - compatible con ambas clases (nueva y antigua)
		const projectItems = heroVideoSection?.querySelectorAll('.title-list__item, .hero-video-project-item') || [];
		const overlay = heroVideoSection?.querySelector('.hero-video-overlay');
		const logo = document.querySelector('.header__logo img, .header__logo');

		console.log('🎥 Elementos encontrados:', {
			originalVideo: !!originalVideo,
			projectVideos: projectVideos.length,
			projectItems: projectItems.length,
			overlay: !!overlay,
			logo: !!logo
		});

		// Asegurar que el video original se reproduzca
		if (originalVideo && originalVideo.tagName === 'VIDEO') {
			originalVideo.addEventListener('canplaythrough', function() {
				originalVideo.play().catch(function(error) {
					console.warn('Video autoplay failed:', error);
				});
			});
		}

		// Iniciar reproducción de videos de proyectos precargados
		projectVideos.forEach(function(video) {
			if (video.tagName === 'VIDEO') {
				video.addEventListener('canplaythrough', function() {
					video.play().catch(function(error) {
						console.warn('Project video autoplay failed:', error);
					});
				});
			}
		});

		// Efecto hover estilo Charlie - mostrar/ocultar elementos precargados
		if (projectItems && projectVideos.length > 0) {
			console.log('🎪 Configurando eventos hover para', projectItems.length, 'project items');

			projectItems.forEach(function(item, index) {
				console.log(`🎯 Configurando item ${index}:`, item);

				// Limpiar eventos anteriores para evitar duplicados
				const newItem = item.cloneNode(true);
				item.parentNode.replaceChild(newItem, item);

				newItem.addEventListener('mouseenter', function() {
					console.log(`🐭 Mouse enter en proyecto ${index}`);
					// Aplicar opacidad 0.5 a todos los otros títulos
					const currentProjectItems = heroVideoSection?.querySelectorAll('.title-list__item, .hero-video-project-item') || [];
					currentProjectItems.forEach(function(otherItem, otherIndex) {
						if (otherIndex !== index) {
							otherItem.style.opacity = '0.5';
						} else {
							otherItem.style.opacity = '1';
						}
					});


					// Ocultar video original
					if (originalVideo) {
						originalVideo.style.opacity = '0';
					}

					// Mostrar video/imagen del proyecto correspondiente
					const projectMedia = heroVideoBlock.querySelector('.hero-video--project[data-project-index="' + index + '"]');
					if (projectMedia) {
						projectMedia.style.opacity = '1';
						projectMedia.style.zIndex = '3';

						// Si es un video, asegurar que se reproduzca
						if (projectMedia.tagName === 'VIDEO') {
							projectMedia.play().catch(function(error) {
								console.warn('Project video play on hover failed:', error);
							});
						}
					}
				});

				newItem.addEventListener('mouseleave', function() {
					// Restaurar opacidad de todos los títulos
					const currentProjectItems = heroVideoSection?.querySelectorAll('.title-list__item, .hero-video-project-item') || [];
					currentProjectItems.forEach(function(otherItem) {
						otherItem.style.opacity = '1';
					});


					// Ocultar video/imagen del proyecto
					const projectMedia = heroVideoBlock.querySelector('.hero-video--project[data-project-index="' + index + '"]');
					if (projectMedia) {
						projectMedia.style.opacity = '0';
						projectMedia.style.zIndex = '3';
					}
				});
			});
		}

		// Evento hover sobre el logo
		if (logo && originalVideo) {
			console.log('🎨 Configurando eventos hover para logo:', logo);

			// Limpiar eventos anteriores del logo
			const newLogo = logo.cloneNode(true);
			logo.parentNode.replaceChild(newLogo, logo);

			newLogo.addEventListener('mouseenter', function() {
				console.log('🐭 Mouse enter en logo');
				// Mostrar video original
				originalVideo.style.opacity = '1';


				// Ocultar todos los videos/imágenes de proyectos
				projectVideos.forEach(function(media) {
					media.style.opacity = '0';
				});

				// Reducir opacidad de todos los títulos de proyectos
				const currentProjectItems = heroVideoSection?.querySelectorAll('.title-list__item, .hero-video-project-item') || [];
				currentProjectItems.forEach(function(item) {
					item.style.opacity = '0.5';
				});

				// Si es un video, asegurar que se reproduzca
				if (originalVideo.tagName === 'VIDEO') {
					originalVideo.play().catch(function(error) {
						console.warn('Original video play on logo hover failed:', error);
					});
				}
			});

			newLogo.addEventListener('mouseleave', function() {
				// Ocultar video original
				originalVideo.style.opacity = '0';


				// Restaurar opacidad de todos los títulos
				const currentProjectItems = heroVideoSection?.querySelectorAll('.title-list__item, .hero-video-project-item') || [];
				currentProjectItems.forEach(function(item) {
					item.style.opacity = '1';
				});
			});
		}
	});
}

/* ------------------ VIDEO PLAYER INTEGRATION ------------------ */

function initHeroVideo() {
	const heroContainer = document.querySelector('#hero-video');
	const customControls = document.querySelector('.custom-video-controls[data-video-id="hero-video"]');
	if (!heroContainer || !customControls) return;

	// Detectar tipo de video
	const video = heroContainer.querySelector('video.hero-local-video');
	const isLocal = !!video;

	if (isLocal) {
		initLocalHeroVideo(video, heroContainer, customControls);
	}
}

function initLocalHeroVideo(video, heroContainer, controls) {
	// Prevenir doble inicialización (causa que togglePlay se ejecute 2 veces y se cancele)
	if (video._heroControlsInit) return;
	video._heroControlsInit = true;

	const projHero = document.querySelector('.proj-hero');
	const playBtn = controls.querySelector('.custom-control-play');
	const playIcon = playBtn?.querySelector('.icon-play');
	const pauseIcon = playBtn?.querySelector('.icon-pause');
	const muteBtn = controls.querySelector('.custom-control-mute');
	const volumeIcon = muteBtn?.querySelector('.icon-volume');
	const mutedIcon = muteBtn?.querySelector('.icon-muted');
	const volumeSlider = controls.querySelector('.custom-control-volume');
	const progressBar = controls.querySelector('.custom-progress-bar');
	const progressFilled = controls.querySelector('.custom-progress-filled');
	const currentTimeEl = controls.querySelector('.custom-time-current');
	const durationEl = controls.querySelector('.custom-time-duration');
	const fullscreenBtn = controls.querySelector('.custom-control-fullscreen');
	const fullscreenIcon = fullscreenBtn?.querySelector('.icon-fullscreen');
	const fullscreenExitIcon = fullscreenBtn?.querySelector('.icon-fullscreen-exit');

	let controlsTimeout = null;

	const formatTime = (s) => {
		if (!s || isNaN(s)) return '0:00';
		return `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}`;
	};

	const showControls = () => { if (projHero) projHero.classList.add('controls-visible'); };
	const hideControls = () => { if (projHero) projHero.classList.remove('controls-visible'); };
	const resetControlsTimeout = () => {
		showControls();
		if (controlsTimeout) clearTimeout(controlsTimeout);
		controlsTimeout = setTimeout(hideControls, 4000);
	};

	// Mouse: mostrar/ocultar controles
	let lastMouseX = null, lastMouseY = null;
	if (projHero) {
		projHero.addEventListener('mousemove', (e) => {
			if (lastMouseX !== null && (e.clientX !== lastMouseX || e.clientY !== lastMouseY)) {
				resetControlsTimeout();
			}
			lastMouseX = e.clientX;
			lastMouseY = e.clientY;
		});
		projHero.addEventListener('mouseleave', () => {
			hideControls();
			lastMouseX = null;
			lastMouseY = null;
		});
	}

	// Play/Pause
	const togglePlay = () => {
		if (video.paused) { video.play().catch(() => {}); }
		else { video.pause(); }
	};

	if (playBtn) playBtn.addEventListener('click', (e) => { e.stopPropagation(); togglePlay(); });
	heroContainer.addEventListener('click', (e) => {
		if (e.target.closest('button') || e.target.closest('input')) return;
		togglePlay();
	});

	video.addEventListener('play', () => {
		if (playIcon) playIcon.style.display = 'none';
		if (pauseIcon) pauseIcon.style.display = 'block';
	});
	video.addEventListener('pause', () => {
		if (playIcon) playIcon.style.display = 'block';
		if (pauseIcon) pauseIcon.style.display = 'none';
		showControls();
	});

	// Mute
	if (muteBtn) muteBtn.addEventListener('click', (e) => {
		e.stopPropagation();
		video.muted = !video.muted;
		if (!video.muted && video.volume === 0) video.volume = 1;
	});

	video.addEventListener('volumechange', () => {
		if (volumeIcon) volumeIcon.style.display = video.muted ? 'none' : 'block';
		if (mutedIcon) mutedIcon.style.display = video.muted ? 'block' : 'none';
		if (volumeSlider) volumeSlider.value = video.muted ? 0 : video.volume * 100;
	});

	// Volume slider
	if (volumeSlider) volumeSlider.addEventListener('input', (e) => {
		const vol = e.target.value / 100;
		video.volume = vol;
		video.muted = vol === 0;
	});

	// Progress bar
	if (progressBar) {
		let isDragging = false;
		const seek = (e) => {
			const rect = progressBar.getBoundingClientRect();
			const pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
			if (video.duration) video.currentTime = pct * video.duration;
		};
		progressBar.addEventListener('click', seek);
		progressBar.addEventListener('mousedown', (e) => { isDragging = true; seek(e); });
		document.addEventListener('mousemove', (e) => { if (isDragging) seek(e); });
		document.addEventListener('mouseup', () => { isDragging = false; });
		progressBar.addEventListener('touchstart', (e) => { isDragging = true; seek(e.touches[0]); });
		document.addEventListener('touchmove', (e) => { if (isDragging) seek(e.touches[0]); });
		document.addEventListener('touchend', () => { isDragging = false; });
	}

	video.addEventListener('timeupdate', () => {
		if (currentTimeEl) currentTimeEl.textContent = formatTime(video.currentTime);
		if (progressFilled && video.duration) {
			progressFilled.style.width = `${(video.currentTime / video.duration) * 100}%`;
		}
	});

	video.addEventListener('loadedmetadata', () => {
		if (durationEl) durationEl.textContent = formatTime(video.duration);
	});
	if (video.duration && durationEl) durationEl.textContent = formatTime(video.duration);

	// Fullscreen
	if (fullscreenBtn) {
		fullscreenBtn.addEventListener('click', () => {
			if (document.fullscreenElement) { document.exitFullscreen(); }
			else { (projHero || heroContainer).requestFullscreen().catch(() => {}); }
		});
		document.addEventListener('fullscreenchange', () => {
			const fs = !!document.fullscreenElement;
			if (fullscreenIcon) fullscreenIcon.style.display = fs ? 'none' : 'block';
			if (fullscreenExitIcon) fullscreenExitIcon.style.display = fs ? 'block' : 'none';
			// En fullscreen: cursor nativo (el custom queda fuera del contexto fullscreen)
			const fsEl = projHero || heroContainer;
			if (fs) {
				fsEl.style.cursor = 'auto';
				resetControlsTimeout();
			} else {
				fsEl.style.cursor = '';
			}
		});
	}

	// Mostrar título y controles brevemente al cargar
	resetControlsTimeout();

	// Iniciar reproducción (autoplay no siempre funciona en navegación SPA con Barba.js)
	video.play().catch(() => {});
}

function initPlyrVideos() {
	// Plyr solo para YouTube y Vimeo
	if (typeof Plyr === 'undefined') return;

	const videoElements = document.querySelectorAll('.plyr-youtube, .plyr-vimeo');

	if (videoElements.length > 0) {
		console.log(`🎬 Inicializando Plyr para ${videoElements.length} videos`);

		const players = Plyr.setup('.plyr-video, .plyr-youtube, .plyr-vimeo', {
			// Ocultar todos los controles de Plyr, usaremos controles personalizados
			controls: false,
			autoplay: true, // Autoplay habilitado para todos los videos
			muted: true,
			loop: {
				active: true
			},
			keyboard: {
				focused: true,
				global: false
			},
			tooltips: {
				controls: true,
				seek: true
			},
			speed: {
				selected: 1,
				options: [0.5, 0.75, 1, 1.25, 1.5, 2]
			},
			// Configuración específica para YouTube - máxima limpieza
			youtube: {
				noCookie: true,
				rel: 0,
				showinfo: 0,
				iv_load_policy: 3,
				modestbranding: 1,
				playsinline: 1,
				controls: 0,
				disablekb: 1,
				fs: 0,
				cc_load_policy: 0,
				enablejsapi: 1
			},
			// Configuración específica para Vimeo
			vimeo: {
				byline: false,
				portrait: false,
				title: false,
				speed: true,
				transparent: false
			}
		});

		// Control de visibilidad de controles con timeout de 4 segundos
		const projHero = document.querySelector('.proj-hero');
		let controlsTimeout = null;
		let lastMouseX = null;
		let lastMouseY = null;

		const showControls = () => {
			if (projHero) {
				projHero.classList.add('controls-visible');
			}
		};

		const hideControls = () => {
			if (projHero) {
				projHero.classList.remove('controls-visible');
			}
		};

		const resetControlsTimeout = () => {
			showControls();
			if (controlsTimeout) {
				clearTimeout(controlsTimeout);
			}
			controlsTimeout = setTimeout(hideControls, 4000); // 4 segundos
		};

		// Solo mostrar controles si el mouse realmente se movió (no scroll)
		const handleMouseMove = (e) => {
			if (lastMouseX !== null && lastMouseY !== null) {
				// Solo activar si la posición cambió
				if (e.clientX !== lastMouseX || e.clientY !== lastMouseY) {
					resetControlsTimeout();
				}
			}
			lastMouseX = e.clientX;
			lastMouseY = e.clientY;
		};

		if (projHero) {
			projHero.addEventListener('mousemove', handleMouseMove);
			projHero.addEventListener('mouseleave', () => {
				hideControls();
				lastMouseX = null;
				lastMouseY = null;
			});
		}

		// Configurar cada player individualmente
		players.forEach((player, index) => {
			console.log(`🎥 Configurando player ${index}`);

			// Conectar controles personalizados con Plyr
			const customControls = document.querySelector('.custom-video-controls[data-video-id="hero-video"]');
			if (customControls && index === 0) { // Solo para el video principal
				// Referencias a elementos (nueva estructura)
				const playBtn = customControls.querySelector('.custom-control-play');
				const playIcon = playBtn?.querySelector('.icon-play');
				const pauseIcon = playBtn?.querySelector('.icon-pause');
				const muteBtn = customControls.querySelector('.custom-control-mute');
				const volumeIcon = muteBtn?.querySelector('.icon-volume');
				const mutedIcon = muteBtn?.querySelector('.icon-muted');
				const volumeSlider = customControls.querySelector('.custom-control-volume');
				const progressBar = customControls.querySelector('.custom-progress-bar');
				const progressFilled = customControls.querySelector('.custom-progress-filled');
				const currentTimeEl = customControls.querySelector('.custom-time-current');
				const durationEl = customControls.querySelector('.custom-time-duration');
				const fullscreenBtn = customControls.querySelector('.custom-control-fullscreen');
				const fullscreenIcon = fullscreenBtn?.querySelector('.icon-fullscreen');	
				const fullscreenExitIcon = fullscreenBtn?.querySelector('.icon-fullscreen-exit');

				// Función para formatear tiempo
				const formatTime = (seconds) => {
					if (!seconds || isNaN(seconds)) return '0:00';
					const minutes = Math.floor(seconds / 60);
					const secs = Math.floor(seconds % 60);
					return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
				};

				// Función para actualizar icono play/pause
				const updatePlayIcon = (isPlaying) => {
					if (playIcon && pauseIcon) {
						playIcon.style.display = isPlaying ? 'none' : 'block';
						pauseIcon.style.display = isPlaying ? 'block' : 'none';
					}
				};

				// Función para actualizar icono mute
				const updateMuteIcon = (isMuted) => {
					if (volumeIcon && mutedIcon) {
						volumeIcon.style.display = isMuted ? 'none' : 'block';
						mutedIcon.style.display = isMuted ? 'block' : 'none';
					}
				};

				// Función para actualizar icono fullscreen
				const updateFullscreenIcon = (isFullscreen) => {
					if (fullscreenIcon && fullscreenExitIcon) {
						fullscreenIcon.style.display = isFullscreen ? 'none' : 'block';
						fullscreenExitIcon.style.display = isFullscreen ? 'block' : 'none';
					}
				};

				// Buscar el <video> directamente en el DOM (sin depender de Plyr)
				const heroContainer = document.querySelector('#hero-video');
				const nativeVideo = heroContainer ? heroContainer.querySelector('video') : null;
				const isLocalVideo = nativeVideo && !player.provider;

				console.log(`🔍 Hero video: isLocal=${isLocalVideo}, provider=${player.provider || 'html5'}`);

				// Helper: toggle play/pause
				const togglePlay = () => {
					if (isLocalVideo) {
						// Video local: controlar directamente el elemento <video>
						if (nativeVideo.paused) {
							nativeVideo.play().catch(() => {});
						} else {
							nativeVideo.pause();
						}
					} else {
						// YouTube/Vimeo: usar API de Plyr
						player.togglePlay();
					}
				};

				// Helper: toggle mute
				const toggleMute = () => {
					if (isLocalVideo) {
						nativeVideo.muted = !nativeVideo.muted;
						if (!nativeVideo.muted && nativeVideo.volume === 0) {
							nativeVideo.volume = 1;
						}
					} else {
						player.muted = !player.muted;
					}
				};

				// Play/Pause - Click en botón
				if (playBtn) {
					playBtn.addEventListener('click', (e) => {
						e.preventDefault();
						e.stopPropagation();
						togglePlay();
					});
				}

				// Play/Pause - Click en el video
				if (heroContainer) {
					heroContainer.addEventListener('click', (e) => {
						if (e.target.closest('.custom-video-controls')) return;
						if (e.target.closest('button')) return;
						if (e.target.closest('input')) return;
						togglePlay();
					});
				}

				// Eventos del video nativo (para videos locales)
				if (nativeVideo) {
					nativeVideo.addEventListener('play', () => {
						updatePlayIcon(true);
						if (controlsTimeout) clearTimeout(controlsTimeout);
						hideControls();
					});

					nativeVideo.addEventListener('pause', () => {
						updatePlayIcon(false);
						showControls();
					});

					nativeVideo.addEventListener('volumechange', () => {
						updateMuteIcon(nativeVideo.muted);
						if (volumeSlider) {
							volumeSlider.value = nativeVideo.muted ? 0 : nativeVideo.volume * 100;
						}
					});
				}

				// Eventos Plyr (para YouTube/Vimeo)
				player.on('play', () => updatePlayIcon(true));
				player.on('pause', () => {
					updatePlayIcon(false);
					showControls();
				});
				player.on('volumechange', () => {
					updateMuteIcon(player.muted);
					if (volumeSlider) {
						volumeSlider.value = player.muted ? 0 : player.volume * 100;
					}
				});

				// Mute/Unmute - Click en botón
				if (muteBtn) {
					muteBtn.addEventListener('click', (e) => {
						e.preventDefault();
						e.stopPropagation();
						toggleMute();
					});
				}

				// Volume slider
				if (volumeSlider) {
					volumeSlider.addEventListener('input', (e) => {
						const vol = e.target.value / 100;
						if (isLocalVideo) {
							nativeVideo.volume = vol;
							nativeVideo.muted = vol === 0;
						} else {
							player.volume = vol;
							player.muted = vol === 0;
						}
					});
				}

				// Progress bar - Click y drag para seek
				if (progressBar) {
					let isDragging = false;

					const seekToPosition = (e) => {
						const rect = progressBar.getBoundingClientRect();
						const percent = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
						const duration = isLocalVideo ? nativeVideo.duration : player.duration;
						if (duration) {
							if (isLocalVideo) {
								nativeVideo.currentTime = percent * duration;
							} else {
								player.currentTime = percent * duration;
							}
						}
					};

					// Click para seek
					progressBar.addEventListener('click', seekToPosition);

					// Drag para seek
					progressBar.addEventListener('mousedown', (e) => {
						isDragging = true;
						seekToPosition(e);
					});

					document.addEventListener('mousemove', (e) => {
						if (isDragging) {
							seekToPosition(e);
						}
					});

					document.addEventListener('mouseup', () => {
						isDragging = false;
					});

					// Touch support para móviles
					progressBar.addEventListener('touchstart', (e) => {
						isDragging = true;
						const touch = e.touches[0];
						seekToPosition(touch);
					});

					document.addEventListener('touchmove', (e) => {
						if (isDragging) {
							const touch = e.touches[0];
							seekToPosition(touch);
						}
					});

					document.addEventListener('touchend', () => {
						isDragging = false;
					});
				}

				// Fullscreen
				if (fullscreenBtn) {
					fullscreenBtn.addEventListener('click', () => {
						if (isLocalVideo) {
							if (document.fullscreenElement) {
								document.exitFullscreen();
							} else {
								const container = heroContainer.closest('.proj-hero') || heroContainer;
								container.requestFullscreen().catch(() => {});
							}
						} else {
							player.fullscreen.toggle();
						}
					});

					document.addEventListener('fullscreenchange', () => {
						const fs = !!document.fullscreenElement;
						updateFullscreenIcon(fs);
						// Cursor nativo en fullscreen (el custom queda fuera del contexto)
						const fsEl = heroContainer ? (heroContainer.closest('.proj-hero') || heroContainer) : null;
						if (fsEl) {
							fsEl.style.cursor = fs ? 'auto' : '';
						}
						if (fs) resetControlsTimeout();
					});
				}

				// Sincronizar estado fullscreen (Plyr - YouTube/Vimeo)
				player.on('enterfullscreen', () => {
					updateFullscreenIcon(true);
					resetControlsTimeout();
				});
				player.on('exitfullscreen', () => updateFullscreenIcon(false));

				// Actualizar tiempo y progreso
				if (isLocalVideo) {
					nativeVideo.addEventListener('timeupdate', () => {
						if (currentTimeEl) currentTimeEl.textContent = formatTime(nativeVideo.currentTime);
						if (progressFilled && nativeVideo.duration) {
							const percent = (nativeVideo.currentTime / nativeVideo.duration) * 100;
							progressFilled.style.width = `${percent}%`;
						}
					});

					nativeVideo.addEventListener('loadedmetadata', () => {
						if (durationEl) durationEl.textContent = formatTime(nativeVideo.duration || 0);
						updatePlayIcon(!nativeVideo.paused);
						updateMuteIcon(nativeVideo.muted);
					});

					// Si ya tiene metadata cargada
					if (nativeVideo.duration) {
						if (durationEl) durationEl.textContent = formatTime(nativeVideo.duration);
						updatePlayIcon(!nativeVideo.paused);
						updateMuteIcon(nativeVideo.muted);
					}
				} else {
					player.on('timeupdate', () => {
						if (currentTimeEl) currentTimeEl.textContent = formatTime(player.currentTime);
						if (progressFilled && player.duration) {
							const percent = (player.currentTime / player.duration) * 100;
							progressFilled.style.width = `${percent}%`;
						}
					});

					player.on('loadedmetadata', () => {
						if (durationEl) durationEl.textContent = formatTime(player.duration || 0);
						updatePlayIcon(player.playing);
						updateMuteIcon(player.muted);
					});

					player.on('ready', () => {
						setTimeout(() => {
							if (durationEl && player.duration) {
								durationEl.textContent = formatTime(player.duration);
							}
						}, 500);
					});
				}
			}

			// Intentar autoplay cuando el player esté listo
			player.on('ready', () => {
				// Solo hacer autoplay si el video original tenía autoplay
				if (player.media.hasAttribute('autoplay')) {
					player.play().catch(error => {
						console.warn('Autoplay failed for Plyr video:', error);
					});
				}

				// Ocultar elementos específicos de YouTube
				if (player.provider === 'youtube') {
					hideYouTubeElements(player);
				}
			});

			// Reset en loop
			player.on('ended', () => {
				// Noop - loop se maneja por Plyr
			});

			// Manejar errores
			player.on('error', (event) => {
				console.error('Plyr player error:', event.detail);
			});
		});

		return players;
	} else {
		console.log('📹 No se encontraron videos con clase plyr-video');
	}
}

// Función para ocultar elementos específicos de YouTube
function hideYouTubeElements(player) {
	// Intentar acceder al iframe de YouTube
	const iframe = player.media;

	if (iframe && iframe.tagName === 'IFRAME') {
		console.log('🎬 Ocultando elementos de YouTube');

		// Agregar CSS personalizado para ocultar elementos de YouTube
		const style = document.createElement('style');
		style.textContent = `
			.plyr-youtube .ytp-chrome-top,
			.plyr-youtube .ytp-show-cards-title,
			.plyr-youtube .ytp-title,
			.plyr-youtube .ytp-title-text,
			.plyr-youtube .ytp-title-channel,
			.plyr-youtube .ytp-watermark,
			.plyr-youtube .ytp-cards-teaser,
			.plyr-youtube .ytp-endscreen-element,
			.plyr-youtube .ytp-ce-element {
				display: none !important;
				visibility: hidden !important;
				opacity: 0 !important;
			}
		`;

		// Agregar el estilo al head si no existe ya
		if (!document.querySelector('#youtube-hide-elements')) {
			style.id = 'youtube-hide-elements';
			document.head.appendChild(style);
		}

		// También intentar con un overlay para cubrir la parte superior
		const container = iframe.closest('.plyr-youtube');
		if (container && !container.querySelector('.youtube-overlay')) {
			const overlay = document.createElement('div');
			overlay.className = 'youtube-overlay';
			overlay.style.cssText = `
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				height: 60px;
				background: transparent;
				z-index: 10;
				pointer-events: none;
			`;
			container.appendChild(overlay);
		}
	}
}

// Función legacy para mantener compatibilidad
function initVideoControls() {
	const videoContainers = document.querySelectorAll('.video-container');

	videoContainers.forEach(container => {
		const video = container.querySelector('video');
		const playPauseBtn = container.querySelector('.play-pause-btn');
		const muteBtn = container.querySelector('.mute-btn');
		const playIcon = playPauseBtn?.querySelector('.play-icon');
		const pauseIcon = playPauseBtn?.querySelector('.pause-icon');
		const volumeIcon = muteBtn?.querySelector('.volume-icon');
		const muteIcon = muteBtn?.querySelector('.mute-icon');

		if (!video || !playPauseBtn || !muteBtn) return;

		// Estado inicial de los controles
		updatePlayPauseButton();
		updateMuteButton();

		// Event listeners
		playPauseBtn.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			togglePlayPause();
		});

		muteBtn.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			toggleMute();
		});

		// Actualizar controles cuando cambie el estado del video
		video.addEventListener('play', updatePlayPauseButton);
		video.addEventListener('pause', updatePlayPauseButton);
		video.addEventListener('volumechange', updateMuteButton);

		// Funciones internas
		function togglePlayPause() {
			if (video.paused) {
				video.play();
			} else {
				video.pause();
			}
		}

		function toggleMute() {
			video.muted = !video.muted;
		}

		function updatePlayPauseButton() {
			if (!playIcon || !pauseIcon) return;

			if (video.paused) {
				playIcon.style.display = 'block';
				pauseIcon.style.display = 'none';
				playPauseBtn.setAttribute('aria-label', 'Reproducir video');
			} else {
				playIcon.style.display = 'none';
				pauseIcon.style.display = 'block';
				playPauseBtn.setAttribute('aria-label', 'Pausar video');
			}
		}

		function updateMuteButton() {
			if (!volumeIcon || !muteIcon) return;

			if (video.muted) {
				volumeIcon.style.display = 'none';
				muteIcon.style.display = 'block';
				muteBtn.setAttribute('aria-label', 'Activar sonido');
			} else {
				volumeIcon.style.display = 'block';
				muteIcon.style.display = 'none';
				muteBtn.setAttribute('aria-label', 'Silenciar video');
			}
		}
	});
}/* ------------------ EFECTO HOVER GLOBAL EN ENLACES ------------------ */
function initGlobalLinkHover() {
	console.log('🔗 Inicializando efecto hover global en enlaces');

	// Obtener todos los enlaces de la página
	const allLinks = document.querySelectorAll('a');

	if (allLinks.length === 0) {
		console.log('📝 No se encontraron enlaces en la página');
		return;
	}

	console.log(`🔗 Encontrados ${allLinks.length} enlaces`);

	// Función para atenuar todos los enlaces excepto el activo
	function dimAllLinksExcept(activeLink) {
		allLinks.forEach(link => {
			// Excluir el logo y los enlaces dentro de project cards
			if (link.classList.contains('custom-logo-link') || link.closest('.project-card')) {
				return;
			}

			if (link !== activeLink) {
				link.classList.add('link-dimmed');
				link.classList.remove('link-active');
			} else {
				link.classList.add('link-active');
				link.classList.remove('link-dimmed');
			}
		});
	}

	// Función para restaurar todos los enlaces
	function restoreAllLinks() {
		allLinks.forEach(link => {
			// Excluir el logo del efecto hover
			if (link.classList.contains('custom-logo-link')) {
				return;
			}

			link.classList.remove('link-dimmed', 'link-active');
		});
	}

	// Agregar eventos a cada enlace
	allLinks.forEach(link => {
		// Excluir el logo de tener eventos hover
		if (link.classList.contains('custom-logo-link')) {
			return;
		}

		// Evitar procesar enlaces ya procesados
		if (link.hasAttribute('data-global-hover')) {
			return;
		}

		link.setAttribute('data-global-hover', 'true');

		link.addEventListener('mouseenter', function() {
			// No interferir con hover propio del hero-video, archive ni project cards
			if (!this.closest('.hero-video-projects') && !this.closest('.projects-archive') && !this.closest('.project-card')) {
				dimAllLinksExcept(this);
			}
		});

		link.addEventListener('mouseleave', function() {
			if (!this.closest('.hero-video-projects') && !this.closest('.projects-archive') && !this.closest('.project-card')) {
				restoreAllLinks();
			}
		});
	});

	console.log('✅ Efecto hover global configurado para todos los enlaces');
}

// Archive de proyectos - hover en título cambia video/imagen + opacidad como home
function initProjectsArchiveEffect() {
	var section = document.querySelector('.projects-archive');
	if (!section) return;

	var mediaCol = section.querySelector('.projects-archive__media-col');
	var titleItems = section.querySelectorAll('.title-list__item[data-project-index]');
	var allMedia = mediaCol.querySelectorAll('.projects-archive__media');

	if (allMedia.length === 0 || titleItems.length === 0) return;

	console.log('🎬 Archive projects: configurando hover para', allMedia.length, 'proyectos');

	var activeIndex = 0;

	// Buscar media por data-project-index (no por posición en el array)
	function findMedia(index) {
		return mediaCol.querySelector('.projects-archive__media[data-project-index="' + index + '"]');
	}

	// Precargar videos
	allMedia.forEach(function(media) {
		if (media.tagName === 'VIDEO') {
			media.addEventListener('canplaythrough', function() {
				media.play().catch(function() {});
			});
			media.load();
		}
	});

	function setActive(index) {
		var currentMedia = findMedia(activeIndex);
		var nextMedia = findMedia(index);

		if (index === activeIndex && nextMedia && nextMedia.classList.contains('is-active')) return;

		if (currentMedia) currentMedia.classList.remove('is-active');

		if (nextMedia) {
			nextMedia.classList.add('is-active');
			if (nextMedia.tagName === 'VIDEO') {
				nextMedia.play().catch(function() {});
			}
		}

		activeIndex = index;
	}

	titleItems.forEach(function(item, i) {
		item.addEventListener('mouseenter', function() {
			var index = parseInt(item.getAttribute('data-project-index'), 10);
			setActive(index);

			// Atenuar los demás títulos (mismo efecto que home)
			titleItems.forEach(function(otherItem, otherIndex) {
				otherItem.style.opacity = (otherIndex === i) ? '1' : '0.5';
			});
		});

		item.addEventListener('mouseleave', function() {
			// Restaurar opacidad de todos
			titleItems.forEach(function(otherItem) {
				otherItem.style.opacity = '1';
			});
		});
	});

	// Excluir del hover global para no interferir
	titleItems.forEach(function(item) {
		var link = item.querySelector('a');
		if (link) {
			link.setAttribute('data-no-global-hover', 'true');
		}
	});
}

// Efecto hover automático en mobile para project cards
function initMobileProjectCardsHover() {
	console.log('📱 Iniciando sistema de hover para project cards');

	const projectCards = document.querySelectorAll('.project-card');

	if (projectCards.length === 0) {
		console.log('❌ No se encontraron project cards');
		return;
	}

	let isMobile = window.innerWidth <= 768;
	console.log('📱 Dispositivo detectado:', isMobile ? 'Mobile' : 'Desktop');

	// Función para limpiar todos los efectos mobile
	function cleanMobileEffects() {
		projectCards.forEach(function(card) {
			const body = card.querySelector('.project-card__body');
			const link = card.querySelector('.project-card__link');
			const defaultMedia = card.querySelector('.project-card__media--default');
			const hoverMedia = card.querySelector('.project-card__media--hover');

			// Limpiar transiciones y estilos
			if (body) {
				body.style.opacity = '';
				body.style.transition = '';
			}
			if (link) {
				link.classList.remove('link-active');
			}
			// Restaurar opacidad en mobile (en desktop se maneja por CSS)
			card.style.opacity = '';
			card.style.transition = '';

			// Restaurar estado de media
			if (defaultMedia) {
				defaultMedia.style.opacity = '';
				defaultMedia.style.transition = '';
			}
			if (hoverMedia) {
				hoverMedia.style.opacity = '';
				hoverMedia.style.transition = '';
			}
		});
	}

	// Función para verificar posición de cards en mobile
	function checkProjectCardsPosition() {
		if (!isMobile) return;

		const viewportHeight = window.innerHeight;
		const activationPoint = viewportHeight * 0.65; // 65% de la pantalla (más arriba que 50%)
		let activeCard = null;

		// Primero encontrar cuál card debe estar activa
		projectCards.forEach(function(card) {
			const rect = card.getBoundingClientRect();
			const cardCenter = rect.top + (rect.height / 2);

			// Si el centro de la card está por encima del 65% de la pantalla
			if (cardCenter < activationPoint && rect.bottom > 0 && rect.top < viewportHeight) {
				activeCard = card;
			}
		});

		// Aplicar estados a todas las cards
		projectCards.forEach(function(card) {
			const body = card.querySelector('.project-card__body');
			const link = card.querySelector('.project-card__link');
			const defaultMedia = card.querySelector('.project-card__media--default');
			const hoverMedia = card.querySelector('.project-card__media--hover');

			if (!body || !link) return;

			// Añadir transiciones suaves si no las tiene
			if (!card.style.transition) {
				card.style.transition = 'opacity 0.6s ease';
			}
			if (!body.style.transition) {
				body.style.transition = 'opacity 0.6s ease';
			}
			if (defaultMedia && !defaultMedia.style.transition) {
				defaultMedia.style.transition = 'opacity 0.6s ease';
			}
			if (hoverMedia && !hoverMedia.style.transition) {
				hoverMedia.style.transition = 'opacity 0.6s ease';
			}

			if (card === activeCard) {
				console.log('🎯 Activando hover en card:', link.textContent?.trim());

				// Activar esta card
				body.style.opacity = '1';
				link.classList.add('link-active');
				card.style.opacity = '1';

				// Cambiar media si existe
				if (defaultMedia && hoverMedia) {
					defaultMedia.style.opacity = '0';
					hoverMedia.style.opacity = '1';
				}
			} else {
				// Desactivar las demás cards
				body.style.opacity = '0';
				link.classList.remove('link-active');
				card.style.opacity = activeCard ? '0.2' : '0.3'; // Más atenuado si hay una activa

				// Restaurar media por defecto
				if (defaultMedia && hoverMedia) {
					defaultMedia.style.opacity = '1';
					hoverMedia.style.opacity = '0';
				}
			}
		});
	}

	// Función para manejar cambios de tamaño de pantalla
	function handleResize() {
		const newIsMobile = window.innerWidth <= 768;

		if (newIsMobile !== isMobile) {
			console.log('📱 Cambio de dispositivo:', newIsMobile ? 'Desktop -> Mobile' : 'Mobile -> Desktop');
			isMobile = newIsMobile;

			// Limpiar efectos previos
			cleanMobileEffects();

			// Si es mobile, aplicar la lógica
			if (isMobile) {
				checkProjectCardsPosition();
			}
		}
	}

	// Configurar eventos solo si es mobile inicialmente
	if (isMobile) {
		console.log('📱 Configurando eventos para mobile');

		// Verificar posición inicial
		setTimeout(checkProjectCardsPosition, 100);

		// Verificar en scroll con throttling
		let scrollTimeout;
		window.addEventListener('scroll', function() {
			if (!isMobile) return;

			clearTimeout(scrollTimeout);
			scrollTimeout = setTimeout(checkProjectCardsPosition, 16); // ~60fps
		}, { passive: true });
	}

	// Manejar cambios de orientación/tamaño
	window.addEventListener('resize', handleResize);

	console.log('✅ Sistema de hover configurado para project cards');
}

// La función initMobileProjectCardsHover se inicializa automáticamente

/**
 * About Team Accordion
 * Maneja el expand/collapse de los miembros del equipo en la página About
 */
// Gestión de opacidad en hover de project cards (desktop)
function initDesktopProjectCardsOpacity() {
	const cards = document.querySelectorAll('.project-card');
	if (cards.length === 0) return;

	cards.forEach(card => {
		if (card._desktopOpacityInit) return;
		card._desktopOpacityInit = true;

		card.addEventListener('mouseenter', () => {
			if (window.innerWidth <= 768) return;
			cards.forEach(c => {
				c.style.opacity = c === card ? '1' : '0.2';
			});
		});

		card.addEventListener('mouseleave', () => {
			if (window.innerWidth <= 768) return;
			cards.forEach(c => {
				c.style.opacity = '0.2';
			});
		});
	});
}

function initAboutTeamAccordion() {
	const toggles = document.querySelectorAll('.about__member-toggle');
	const detailsContainer = document.querySelector('.about__team-details');

	if (toggles.length === 0 || !detailsContainer) return;

	console.log('🔍 Iniciando accordion de equipo');

	toggles.forEach(function(toggle) {
		// Guard para evitar doble inicialización (Barba.js)
		if (toggle._aboutAccordionInit) return;
		toggle._aboutAccordionInit = true;

		toggle.addEventListener('click', function() {
			const isExpanded = this.getAttribute('aria-expanded') === 'true';

			if (isExpanded) {
				// Cerrar: ocultar detalles
				this.setAttribute('aria-expanded', 'false');

				// Verificar si queda alguno abierto
				const anyOpen = Array.from(toggles).some(function(t) {
					return t !== toggle && t.getAttribute('aria-expanded') === 'true';
				});

				if (!anyOpen) {
					detailsContainer.classList.remove('is-visible');
				}
			} else {
				// Abrir: mostrar detalles
				this.setAttribute('aria-expanded', 'true');
				detailsContainer.classList.add('is-visible');
			}
		});
	});
}
// a través del sistema Barba.js en contentAnimation()

function initMobileProjectSlider() {
	const section = document.querySelector('.prod-imgs');
	if (!section) return;

	// Recoger elementos visibles en móvil:
	// columnas .mobile + columnas sin .tablet (desktop sin alternativa móvil)
	const mobileEls = Array.from(
		section.querySelectorAll('.prod-imgs__col:not(.mobile) img, .prod-imgs__col:not(.mobile) video')
	);
	if (!mobileEls.length) return;

	// Recoger datos de cada media
	const items = mobileEls.map((el) => {
		if (el.tagName.toLowerCase() === 'video') {
			const source = el.querySelector('source');
			return { type: 'video', src: el.src || (source ? source.src : ''), mime: source ? source.type : 'video/mp4' };
		}
		return { type: 'img', src: el.src, alt: el.alt || '' };
	});

	function openSlider(startIndex) {

		let currentIndex = startIndex;
		let touchStartX  = 0;

		// Construir overlay
		const overlay = document.createElement('div');
		overlay.className = 'mobile-slider-overlay';
		overlay.innerHTML = `
			<button class="mobile-slider-overlay__close" aria-label="Cerrar">&#x2715;</button>
			<div class="mobile-slider-overlay__viewport">
				<div class="mobile-slider-overlay__track"></div>
			</div>
			<button class="mobile-slider-overlay__prev" aria-label="Anterior">&#x2190;</button>
			<button class="mobile-slider-overlay__next" aria-label="Siguiente">&#x2192;</button>
			<div class="mobile-slider-overlay__counter"></div>
		`;
		document.body.appendChild(overlay);
		document.body.classList.add('mobile-slider-open');

		const track    = overlay.querySelector('.mobile-slider-overlay__track');
		const counter  = overlay.querySelector('.mobile-slider-overlay__counter');
		const closeBtn = overlay.querySelector('.mobile-slider-overlay__close');
		const prevBtn  = overlay.querySelector('.mobile-slider-overlay__prev');
		const nextBtn  = overlay.querySelector('.mobile-slider-overlay__next');

		// Construir slides
		items.forEach((item) => {
			const slide = document.createElement('div');
			slide.className = 'mobile-slider-overlay__slide';
			if (item.type === 'video') {
				const video = document.createElement('video');
				video.muted = true;
				video.loop  = true;
				video.setAttribute('playsinline', '');
				const source = document.createElement('source');
				source.src  = item.src;
				source.type = item.mime;
				video.appendChild(source);
				slide.appendChild(video);
				initSliderVideoControls(video, slide);
			} else {
				const img = document.createElement('img');
				img.src = item.src;
				img.alt = item.alt;
				slide.appendChild(img);
			}
			track.appendChild(slide);
		});

		function update(animate) {
			track.style.transition = animate === false ? 'none' : 'transform 0.35s ease';
			track.style.transform  = `translateX(-${currentIndex * 100}%)`;
			counter.textContent    = `${currentIndex + 1} / ${items.length}`;
			track.querySelectorAll('video').forEach((v, i) => {
				i === currentIndex ? v.play().catch(() => {}) : v.pause();
			});
			prevBtn.style.display = items.length <= 1 ? 'none' : '';
			nextBtn.style.display = items.length <= 1 ? 'none' : '';
			dragDelta = 0;
		}

		function close() {
			track.querySelectorAll('video').forEach((v) => v.pause());
			document.body.classList.remove('mobile-slider-open');
			document.removeEventListener('keydown', onKey);
			overlay.remove();
		}

		function onKey(e) {
			if (e.key === 'Escape')     close();
			if (e.key === 'ArrowRight') { currentIndex = (currentIndex + 1) % items.length; update(); }
			if (e.key === 'ArrowLeft')  { currentIndex = (currentIndex - 1 + items.length) % items.length; update(); }
		}

		closeBtn.addEventListener('click', close);
		prevBtn.addEventListener('click', () => { currentIndex = (currentIndex - 1 + items.length) % items.length; update(); });
		nextBtn.addEventListener('click', () => { currentIndex = (currentIndex + 1) % items.length; update(); });
		overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
		document.addEventListener('keydown', onKey);

		const viewport = overlay.querySelector('.mobile-slider-overlay__viewport');
		let dragStartX = 0;
		let dragDelta  = 0;
		let isDragging = false;

		function getBaseOffset() {
			return -(currentIndex * viewport.clientWidth);
		}

		function onDragStart(x) {
			dragStartX = x;
			dragDelta  = 0;
			isDragging = true;
			track.style.transition = 'none';
		}

		function onDragMove(x) {
			if (!isDragging) return;
			dragDelta = x - dragStartX;
			track.style.transform = `translateX(${getBaseOffset() + dragDelta}px)`;
		}

		function onDragEnd() {
			if (!isDragging) return;
			isDragging = false;
			const threshold = viewport.clientWidth * 0.2;
			if (dragDelta < -threshold && currentIndex < items.length - 1) {
				currentIndex++;
			} else if (dragDelta > threshold && currentIndex > 0) {
				currentIndex--;
			}
			update();
		}

		// Touch
		viewport.addEventListener('touchstart', (e) => onDragStart(e.touches[0].clientX), { passive: true });
		viewport.addEventListener('touchmove',  (e) => onDragMove(e.touches[0].clientX),  { passive: true });
		viewport.addEventListener('touchend',   () => onDragEnd());

		// Mouse
		viewport.addEventListener('mousedown', (e) => { e.preventDefault(); onDragStart(e.clientX); });
		window.addEventListener('mousemove',   (e) => { if (isDragging) onDragMove(e.clientX); });
		window.addEventListener('mouseup',     () => { if (isDragging) onDragEnd(); });

		// Evitar que el drag active el click en imágenes
		viewport.addEventListener('dragstart', (e) => e.preventDefault());

		update(false);
	}

	// Asignar click a cada elemento (guard para evitar duplicados con Barba)
	mobileEls.forEach((el, i) => {
		if (el._sliderClick) return;
		el._sliderClick = true;
		el.addEventListener('click', () => openSlider(i));
	});
}

function initSliderVideoControls(video, slideContainer) {
	const formatTime = (s) => {
		if (!s || isNaN(s)) return '0:00';
		return `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}`;
	};

	slideContainer.insertAdjacentHTML('beforeend', `
		<div class="custom-video-controls">
			<div class="custom-controls-center">
				<button class="custom-control-play" aria-label="Reproducir/Pausar">
					<svg class="icon-play" viewBox="0 0 24 24" fill="currentColor" style="display:none"><path d="M8 5v14l11-7z"/></svg>
					<svg class="icon-pause" viewBox="0 0 24 24" fill="currentColor"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>
				</button>
				<span class="custom-time-current">0:00</span>
				<span class="custom-time-separator">-</span>
				<span class="custom-time-duration">0:00</span>
			</div>
			<div class="custom-controls-right">
				<button class="custom-control-mute" aria-label="Activar/Desactivar sonido">
					<svg class="icon-volume" viewBox="0 0 24 24" fill="currentColor" style="display:none"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>
					<svg class="icon-muted" viewBox="0 0 24 24" fill="currentColor"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>
				</button>
				<input type="range" class="custom-control-volume" min="0" max="100" value="0" aria-label="Volumen">
				<button class="custom-control-fullscreen" aria-label="Pantalla completa">
					<svg class="icon-fullscreen" viewBox="0 0 24 24" fill="currentColor"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>
					<svg class="icon-fullscreen-exit" viewBox="0 0 24 24" fill="currentColor" style="display:none"><path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/></svg>
				</button>
			</div>
			<div class="custom-controls-progress">
				<div class="custom-progress-bar">
					<div class="custom-progress-filled"></div>
				</div>
			</div>
		</div>
	`);

	const controls          = slideContainer.querySelector('.custom-video-controls');
	const playBtn           = controls.querySelector('.custom-control-play');
	const playIcon          = playBtn.querySelector('.icon-play');
	const pauseIcon         = playBtn.querySelector('.icon-pause');
	const muteBtn           = controls.querySelector('.custom-control-mute');
	const volumeIcon        = muteBtn.querySelector('.icon-volume');
	const mutedIcon         = muteBtn.querySelector('.icon-muted');
	const volumeSlider      = controls.querySelector('.custom-control-volume');
	const progressBar       = controls.querySelector('.custom-progress-bar');
	const progressFilled    = controls.querySelector('.custom-progress-filled');
	const currentTimeEl     = controls.querySelector('.custom-time-current');
	const durationEl        = controls.querySelector('.custom-time-duration');
	const fullscreenBtn     = controls.querySelector('.custom-control-fullscreen');
	const fullscreenIcon    = fullscreenBtn.querySelector('.icon-fullscreen');
	const fullscreenExitIcon = fullscreenBtn.querySelector('.icon-fullscreen-exit');

	let controlsTimeout = null;

	const showControls = () => slideContainer.classList.add('controls-visible');
	const hideControls = () => slideContainer.classList.remove('controls-visible');
	const resetControlsTimeout = () => {
		showControls();
		if (controlsTimeout) clearTimeout(controlsTimeout);
		controlsTimeout = setTimeout(hideControls, 4000);
	};

	slideContainer.addEventListener('mousemove', resetControlsTimeout);
	slideContainer.addEventListener('mouseleave', () => { hideControls(); clearTimeout(controlsTimeout); });
	slideContainer.addEventListener('touchstart', resetControlsTimeout, { passive: true });

	// Play/Pause
	const togglePlay = () => { video.paused ? video.play().catch(() => {}) : video.pause(); };
	playBtn.addEventListener('click', (e) => { e.stopPropagation(); togglePlay(); });
	slideContainer.addEventListener('click', (e) => {
		if (e.target.closest('button') || e.target.closest('input')) return;
		togglePlay();
	});

	video.addEventListener('play',  () => { playIcon.style.display = 'none';  pauseIcon.style.display = 'block'; });
	video.addEventListener('pause', () => { playIcon.style.display = 'block'; pauseIcon.style.display = 'none'; showControls(); });

	// Mute
	muteBtn.addEventListener('click', (e) => {
		e.stopPropagation();
		video.muted = !video.muted;
		if (!video.muted && video.volume === 0) video.volume = 1;
	});
	video.addEventListener('volumechange', () => {
		volumeIcon.style.display = video.muted ? 'none'  : 'block';
		mutedIcon.style.display  = video.muted ? 'block' : 'none';
		volumeSlider.value = video.muted ? 0 : video.volume * 100;
	});
	volumeSlider.addEventListener('input', (e) => {
		const vol = e.target.value / 100;
		video.volume = vol;
		video.muted  = vol === 0;
	});

	// Barra de progreso
	let isDragging = false;
	const seek = (e) => {
		const rect = progressBar.getBoundingClientRect();
		const pct  = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
		if (video.duration) video.currentTime = pct * video.duration;
	};
	progressBar.addEventListener('click', seek);
	progressBar.addEventListener('mousedown', (e) => { isDragging = true; seek(e); });
	document.addEventListener('mousemove',  (e) => { if (isDragging) seek(e); });
	document.addEventListener('mouseup',    () => { isDragging = false; });
	progressBar.addEventListener('touchstart', (e) => { isDragging = true; seek(e.touches[0]); }, { passive: true });
	document.addEventListener('touchmove',  (e) => { if (isDragging) seek(e.touches[0]); }, { passive: true });
	document.addEventListener('touchend',   () => { isDragging = false; });

	video.addEventListener('timeupdate', () => {
		currentTimeEl.textContent = formatTime(video.currentTime);
		if (video.duration) progressFilled.style.width = `${(video.currentTime / video.duration) * 100}%`;
	});
	video.addEventListener('loadedmetadata', () => { durationEl.textContent = formatTime(video.duration); });

	// Fullscreen
	fullscreenBtn.addEventListener('click', () => {
		document.fullscreenElement ? document.exitFullscreen() : slideContainer.requestFullscreen().catch(() => {});
	});
	document.addEventListener('fullscreenchange', () => {
		const fs = !!document.fullscreenElement;
		fullscreenIcon.style.display     = fs ? 'none'  : 'block';
		fullscreenExitIcon.style.display = fs ? 'block' : 'none';
	});

	resetControlsTimeout();
}